import { getCurrentInstance } from 'vue';

export const useContext = () => {
  const vm = getCurrentInstance();

  if (!vm) {
    throw new Error('useContext() must be called within a setup function');
  }

  return vm.proxy.$root.$options.context;
};
